<template>
  <div>
    <vue-snotify></vue-snotify>
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      :loader="$store.state.spinerLoader"
      :color="$store.state.spinerColor"
    ></loading>

    <b-row>
      <b-col lg="12">
        <b-tabs>
          <b-tab title="All Tax Centers" @click="loadAllClientTaxCenters()">
            <b-card-text>
              <b-card>
                <b-row>
                  <b-col cols="12">
                    <vuetable
                      ref="vuetableAllClientsTaxCenters"
                      :api-mode="false"
                      :fields="fields"
                      :per-page="perPage"
                      :data-manager="dataManagerAllClientsTaxCenters"
                      pagination-path="pagination"
                      @vuetable:pagination-data="
                        onPaginationDataAllClientsTaxCenters
                      "
                    >
                    </vuetable>
                  </b-col>
                  <b-col cols="12" class="pt-2">
                    <vuetable-pagination-info
                      ref="paginationInfoAllClientsTaxCenters"
                    ></vuetable-pagination-info>
                    <vuetable-pagination
                      class="float-right"
                      ref="paginationAllClientTaxCenters"
                      @vuetable-pagination:change-page="
                        onChangePageAllClientsTaxCenters
                      "
                    ></vuetable-pagination>
                  </b-col>
                </b-row>
              </b-card>
            </b-card-text>
          </b-tab>
          <b-tab title="Upload Tax Centers" active>
            <b-card-text>
              <b-card>
                <b-row align-v="center" slot="header">
                  <b-col cols="8">
                    <h3 class="mb-0">Upload Tax Centers</h3>
                  </b-col>
                  <b-col cols="4" class="text-right">
                    <b-button
                      v-if="excelError == 0"
                      id="confirm-btn"
                      class="btn btn-sm btn-outline-success"
                      @click="confirmAction"
                    >
                      <i class="fa fa-check"></i>
                      Confirm</b-button
                    >

                    <span v-if="excelError == 1" class="pl-3 mr-2 text-red"
                      >Invalid Excel Data</span
                    >

                    <b-button
                      id="show-btn"
                      @click="$bvModal.show('bv-modal-tax-centers')"
                      class="btn btn-sm btn-outline-primary"
                    >
                      <i class="fa fa-upload"></i>
                      Upload</b-button
                    >
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <vuetable
                      ref="vuetableExcel"
                      :api-mode="false"
                      :fields="excelFields"
                      :per-page="perPage"
                      :data-manager="dataManagerExcel"
                      pagination-path="pagination"
                      @vuetable:pagination-data="onPaginationDataExcel"
                    >
                    </vuetable>
                  </b-col>
                  <b-col cols="12" class="pt-2">
                    <vuetable-pagination-info
                      ref="paginationInfoExcel"
                    ></vuetable-pagination-info>
                    <vuetable-pagination
                      class="float-right"
                      ref="pagination_excel"
                      @vuetable-pagination:change-page="onChangePageExcel"
                    ></vuetable-pagination>
                  </b-col>
                </b-row>
              </b-card>
            </b-card-text>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>

    <b-modal id="bv-modal-tax-centers" hide-footer>
      <template #modal-title>
        <h3>Upload a File</h3>
      </template>
      <div class="d-block">
        <b-row>
          <b-col lg="10">
            <div class="form-group">
              <div>
                <b-form-file
                  v-model="excel_file"
                  variant="primary"
                  placeholder="Choose a file or drop it here..."
                  drop-placeholder="Drop file here..."
                ></b-form-file>

                <b-progress
                  :value="client_tax_center_upload_progress"
                  :max="max"
                  show-progress
                  animated
                  class="mt-2"
                  variant="warning"
                  v-if="isUploading == 1"
                  height="1.5rem"
                ></b-progress>
              </div>
            </div>
          </b-col>
          <b-col lg="2">
            <b-button
              variant=""
              :disabled="isUploading == 1"
              @click="excel_file = null"
              ><i class="fa fa-refresh" aria-hidden="true"></i>
            </b-button>
          </b-col>
        </b-row>
      </div>

      <div class="float-right mt-3">
        <b-button
          variant="primary"
          @click="uploadExcelFile()"
          :disabled="!excel_file || isUploading == 1"
          >Upload</b-button
        >
        <b-button variant="" @click="$bvModal.hide('bv-modal-tax-centers')"
          >Cancel</b-button
        >
      </div>
    </b-modal>
    <!-- End Upload Model -->
  </div>
</template>

<script>
import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "../../../Vuetable/VuetablePaginationBootstrap4.vue";
import VuetablePaginationInfo from "vuetable-2/src/components/VuetablePaginationInfo.vue";
import { mapActions, mapState } from "vuex";
import _ from "lodash";
import AllClientsTaxDef from "./AllClientsTaxDef.js";
import ExcelDef from "./ExcelDef.js";
import mixins from "./../../../../mixins/common.js";

export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
  },
  mixins: [mixins],
  data() {
    return {
      excel_file: null,
      perPage: 10,
      allClientsTaxCenters: [],
      excelData: [],
      fields: AllClientsTaxDef,
      excelFields: ExcelDef,
      fullPage: true,
      isLoading: false,
      excelError: null,
      value: 0,
      max: 100,
      isUploading: 0,
    };
  },
  watch: {
    excelData(newVal, oldVal) {
      this.$refs.vuetableExcel.refresh();
    },
    allClients(newVal, oldVal) {
      this.$refs.vuetableAllClientsTaxCenters.refresh();
    },
    allClientsTaxCenters(newVal, oldVal) {
      this.$refs.vuetableAllClientsTaxCenters.refresh();
    },
  },
  methods: {
    ...mapActions("admin", [
      "excelFileReadClientTaxCenters",
      "confirmFileUploadClientTaxCenters",
      "getAllClientsTaxCenters",
    ]),
    loadAllClientTaxCenters() {
      this.isLoading = true;
      this.getAllClientsTaxCenters().then((data) => {
        if (data.data) {
          this.allClientsTaxCenters = data.data;
        }
        this.isLoading = false;
      });
    },
    confirmAction() {
      this.isLoading = true;
      this.confirmFileUploadClientTaxCenters().then((data) => {
        if (data.data.success && data.data.success.status) {
          this.excelError = null;
          this.excelData = [];
        }
        this.isLoading = false;
        this.$parent.refreshLastModified();
      });
    },
    uploadExcelFile() {
      let formData = new FormData();
      formData.append("file", this.excel_file);
      this.isUploading = 1;
      this.excelFileReadClientTaxCenters(formData).then((data) => {
        if (data.data && data.data.error && data.data.error.status == "false") {
          this.excelError = 0;
        } else {
          this.excelError = 1;
        }
        if (data.data.data) {
          this.excelData = _.orderBy(data.data.data, ["IsValid"]);
          this.$bvModal.hide("bv-modal-tax-centers");
        } else {
          this.$bvModal.hide("bv-modal-tax-centers");
        }
        this.isUploading = 0;
        this.client_tax_center_upload_progress = 0;
      });
    },
    onPaginationDataAllClientsTaxCenters(paginationData) {
      this.$refs.paginationAllClientTaxCenters.setPaginationData(
        paginationData
      );
      this.$refs.paginationInfoAllClientsTaxCenters.setPaginationData(
        paginationData
      );
    },
    onChangePageAllClientsTaxCenters(page) {
      this.$refs.vuetableAllClientsTaxCenters.changePage(page);
    },
    dataManagerAllClientsTaxCenters(sortOrder, pagination) {
      let local = [];

      local = this.allClientsTaxCenters;

      // sortOrder can be empty, so we have to check for that as well
      if (sortOrder.length > 0) {
        local = _.orderBy(
          local,
          sortOrder[0].sortField,
          sortOrder[0].direction
        );
      }

      pagination = this.$refs.vuetableAllClientsTaxCenters.makePagination(
        local.length,
        this.perPage
      );
      let from = pagination.from - 1;
      let to = from + this.perPage;
      return {
        pagination: pagination,
        data: _.slice(local, from, to),
      };
    },

    onPaginationDataExcel(paginationData) {
      this.$refs.pagination_excel.setPaginationData(paginationData);
      this.$refs.paginationInfoExcel.setPaginationData(paginationData);
    },
    onChangePageExcel(page) {
      this.$refs.vuetableExcel.changePage(page);
    },
    dataManagerExcel(sortOrder, pagination) {
      let local = [];

      local = this.excelData;

      // sortOrder can be empty, so we have to check for that as well
      if (sortOrder.length > 0) {
        local = _.orderBy(
          local,
          sortOrder[0].sortField,
          sortOrder[0].direction
        );
      }

      pagination = this.$refs.vuetableExcel.makePagination(
        local.length,
        this.perPage
      );
      let from = pagination.from - 1;
      let to = from + this.perPage;
      return {
        pagination: pagination,
        data: _.slice(local, from, to),
      };
    },
  },
  computed: {
    client_tax_center_upload_progress: {
      get() {
        return this.$store.state.admin.client_tax_center_upload_progress;
      },
      set(val) {
        this.$store.state.admin.client_tax_center_upload_progress = val;
      },
    },
  },
  mounted(){
    //clear snotofy 
    this.clearSnotifyMessages();
  }
};
</script>

<style scoped>
.label-size {
  font-size: 0.7rem;
  font-weight: 300;
  line-height: 1.7;
}

.color-block {
  margin-left: 2px;
  margin-right: 2px;
  margin-top: 5px;
  float: right;
  min-height: 12px;
  min-width: 12px;
  max-height: 12px;
  max-width: 12px;
}

</style>
